module.exports = __webpack_public_path__ + "static/clients-kana.133d2a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-kana.png
// module id = 931
// module chunks = 241767136424496